import * as React from 'react';
import { useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import { SelectInputCheckBoxStyle } from '../StyledComponent'
import { CustomDropdownIcon } from '../CustomDropDownIcon';


const ITEM_HEIGHT = 36;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: '200px',
        },
    },
};

export const SelectInput = ({ filterArray = [], setSelectedDay, selectedDay }) => {
    const placeholder = "a day"
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedDay(value);
    };

    return (
        <div className="flex flex-row">
            <FormControl sx={{ padding: 0, display: 'flex', minWidth: '28' }} className='border border-solid border-gray-100 rounded-xl'>
                <Select
                    displayEmpty
                    disabled={filterArray.length === 0}
                    value={selectedDay}
                    IconComponent={CustomDropdownIcon}
                    onChange={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleChange(e);
                    }} input={<OutlinedInput sx={{ padding: 0, margin: 0 }} />}
                    renderValue={() => (
                        <div className="flex flex-row align-center relative ">
                            <div className="overflow-hidden text-gray-700 truncate text-base font-normal leading-6">
                                {`${selectedDay && filterArray.length > 0 ? selectedDay : placeholder}`}
                            </div>
                        </div>
                    )}
                    sx={SelectInputCheckBoxStyle}
                    MenuProps={MenuProps}
                >
                    {filterArray.map((name) => (
                        <MenuItem key={name} value={name} className='flex w-full flex-col bg-mb-gray-500 border border-solid border-gray-100 rounded-lg'>
                            <div className="flex flex-row gap-2 px-2 w-full">
                                <ListItemText primary={name} className=' text-base text-[#252D38] font-normal' />
                            </div>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
